import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormHelperText,
  Typography,
} from '@mui/material';
import { ContractType, UserContract } from '@nrdy-marketing-engine/cart/@types/contract';
import { Control, Controller } from 'react-hook-form';
import * as styles from './agree-to-terms.css';

type UserContractLinks = Record<ContractType, string>;

export function UserContractLinks({
  agreeText,
  ecom,
  tou,
}: {
  agreeText: string;
  ecom: string;
  tou: string;
}) {
  return (
    <Typography fontSize={14}>
      {agreeText}
      <a className={styles.link} href={ecom} target="_blank">
        Electronic Consent
      </a>{' '}
      and{' '}
      <a className={styles.link} href={tou} target="_blank">
        Terms of Customer Account Use
      </a>
      .
    </Typography>
  );
}

function getContractLink(contracts: UserContract[], type: ContractType) {
  if (!contracts) return;
  const contract = contracts?.find((contract) => contract.contract_type === type);
  if (!contract) {
    return;
  }
  return `${process.env.NEXT_PUBLIC_VT_WWW_ENDPOINT}/contracts/${contract.uuid}/info`;
}

export function AgreeToTermsLabel({ contracts = [] }: { contracts: UserContract[] }) {
  const agreeTextToUse = 'I agree to the ';
  const ecom = getContractLink(contracts, 'ecom_consent');
  const tou = getContractLink(contracts, 'tou');
  if (ecom && tou) {
    return (
      <>
        <UserContractLinks agreeText={agreeTextToUse} ecom={ecom} tou={tou} />
      </>
    );
  }
  return (
    <>
      {agreeTextToUse}
      <a className={styles.link} href="/terms-of-use" target="_blank">
        Terms of Service
      </a>
    </>
  );
}

const AgreeToTermsCheckbox = ({ Label, ...props }: any) => (
  <FormControlLabel control={<Checkbox {...props} />} label={Label} />
);

function AgreeToTerms({
  contracts,
  control,
  errorMessage,
  ...fieldProps
}: {
  contracts: UserContract[];
  control: Control<any>;
  errorMessage?: string;
} & CheckboxProps) {
  return (
    <>
      <Controller
        control={control}
        name="agreeToTerms"
        render={({ field: { ref, ...field } }) => (
          <AgreeToTermsCheckbox
            Label={<AgreeToTermsLabel contracts={contracts} />}
            {...field}
            {...fieldProps}
          />
        )}
        rules={{
          required: `You must agree to the ${
            contracts?.length > 0
              ? 'Electronic Consent and Terms of Customer Account Use'
              : 'Terms of Service'
          }.`,
        }}
      />
      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </>
  );
}

export default AgreeToTerms;
